import config from "@/config";
import errors from "@/errors";
import Vue from "vue";

export default {
  loading: {
    cashout: false,
    cashoutCheck: false,
  },
  betCashoutCheck(args) {
    const url = config.betCashoutCheckUrl() + "?id=" + args.betID;
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "betCashoutCheck",
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      // Validate required fields based on the JSON sample
      const requiredFields = [
        "moMatchID",
        "betType",
        "placementRunningScore",
        "homeGiving",
        "placementBall",
        "placementTeam",
        "betStatus",
        "betMember",
        "cashOutTime"
      ];
      for (const field of requiredFields) {
        if (!(field in args)) {
          feedback.status = errors.request.incompleted;
          reject(feedback);
          canRequest = false;
        }
      }

      // if (this.loading.cashoutCheck == true) {
      //   feedback.status = errors.request.processing;
      //   canRequest = false;
      // }

      if (canRequest == true) {
        this.loading.cashoutCheck = true;
        Vue.http.post(url, args).then(
          (res) => {
            this.loading.cashoutCheck = false;
            if (res.data) {
              // check status code
              if (typeof res.data.status == "string") {
                feedback.success = res.data.status == "1";
              } else {
                feedback.success = res.data.status == 1;
              }

              feedback.status = res.data.statusdesc;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data;
                  resolve(feedback);
                } catch (error) {
                  // Failed to process response
                  feedback.success = false;
                  feedback.status = error;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          (err) => {
            this.loading.cashoutCheck = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },
  betCashout(args) {
    const url = config.betCashoutUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "betCashout",
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      // console.log(args);

      // Validate required fields based on the JSON sample
      const requiredFields = [
        "betID",
        "moMatchID",
        "betType",
        "placementRunningScore",
        "homeGiving",
        "placementBall",
        "placementTeam",
        "betStatus",
        "betMember",
        "cashOutTime",
        "cashout_amt",
      ];
      for (const field of requiredFields) {
        if (!(field in args)) {
          feedback.status = errors.request.incompleted;
          reject(feedback);
          canRequest = false;
        }
      }

      if (this.loading.cashout == true) {
        feedback.status = errors.request.processing;
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.cashout = true;
        Vue.http.post(url, args).then(
          (res) => {
            this.loading.cashout = false;
            if (res.data) {
              // check status code
              if (typeof res.data.status == "string") {
                feedback.success = res.data.status == "1";
              } else {
                feedback.success = res.data.status == 1;
              }

              feedback.status = res.data.statusdesc;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data;
                  resolve(feedback);
                } catch (error) {
                  // Failed to process response
                  feedback.success = false;
                  feedback.status = error;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          (err) => {
            this.loading.cashout = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },
};
